function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*jshint esversion: 6 */
export var TextFormatter = /*#__PURE__*/function () {
  function TextFormatter(value) {
    _classCallCheck(this, TextFormatter);

    this._value = !!value ? String(value) : "";
  }
  /**
   * This function is needed to honor line breaks
   * @param {*} textValue - string
   */


  _createClass(TextFormatter, [{
    key: "addLineBreaks",
    value: function addLineBreaks() {
      return this._value.replace(/(?:\r\n|\r|\n)/g, "<br />");
    }
  }]);

  return TextFormatter;
}();